module.exports = {
  "State": { "@id": "dtmi:iotcentral:class:State;2" },
  "Event": { "@id": "dtmi:iotcentral:class:Event;2" },
  "Location": { "@id": "dtmi:iotcentral:class:Location;2" },
  "VelocityVector": { "@id": "dtmi:iotcentral:class:VelocityVector;2" },
  "AccelerationVector": { "@id": "dtmi:iotcentral:class:AccelerationVector;2" },
  "vector": { "@id": "dtmi:iotcentral:schema:vector;2" }
}